import { http } from '../../config/axios'

export default function getPerfilOpcoes(): Promise<any[]> {
  return http
    .get('api/perfil/opcoes')
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getPerfilOpcoes', error)
      throw Error(error.response.data)
    })
}
